<div class="">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">TRANSFER OPPORTUNITY</h4>
      <button type="button" class="close headerClose" (click)="close()" >&times;</button>
    </div>
    <form #theForm="ngForm" name="theForm" (ngSubmit)="confirm()">
    <div class="modal-body" style="height: 220px;">
      <div>
        <div>
          <label>Opportunity Name:</label>
          <input type="text" class="form-control" placeholder="Enter Opportunity name"  [(ngModel)]="opportunity_name" name="opp_name" #opp_name="ngModel" required/>
          <div class="error" *ngIf="!opp_name.valid && (opp_name.touched || opp_name.dirty)">
            <span *ngIf="opp_name.errors.required">Please enter the Opportunity Name.</span>
          </div>
        </div>
        <div style="padding-top: 15px;">
          <label>Username:</label>
          <input type="text" class="form-control" placeholder="Enter username" name="username" [(ngModel)]="opportunity_username" #username="ngModel" required/>
          <div class="error" *ngIf="!username.valid && (username.touched || username.dirty)">
            <span *ngIf="username.errors.required">Please enter the Username.</span>
          </div>
        </div>
        <div class="mb-2 pt-2" style="overflow: hidden;">
          <span class="fontFamilySemi">Note:
            <br>
          </span> Opportunity will be transferred with name <span class="fontFamilySemi">'{{opportunity_name}}_prod'</span>.
        </div>
      </div>
    </div>
    <div class="modal-footer" style="text-align:right">
      <button type="button" class="btn cancel_btn width100 float-left" (click)="close()">Cancel</button>
      <button type="submit" class="btn action_btn width100" [disabled]="enableValidation(theForm)">Save</button>
    </div>
  </form>
  </div>
</div>